import { showErrorMessage, showSuccessMessage } from 'helpers';
import styles from './styles.module.scss';
import { Menu, MenuItem, Dropdown } from 'components-antd';
import { Icons } from 'pages/Profile/components/icons';
import { useHistory } from 'react-router-dom';
import { routes } from 'settings/navigation/routes';

const ClientActionsMenu = ({ client, handleReassignClick, limitedAccess }) => {
  const history = useHistory();

  const handleViewProfile = () => {
    history.push(`${routes.clientProfile}/${client.Id}`);
  };

  const handleCopyInviteLink = () => {
    if (!client.InvitationLink) {
      showErrorMessage('Invitation link not found');
      return;
    }

    navigator.clipboard.writeText(client.InvitationLink);
    showSuccessMessage('Invitation link copied.');
  };

  const menu = (
    <Menu className={styles.clientActionsMenuDD} onClick={(e) => {}}>
      <MenuItem
        key={'view'}
        icon={<Icons variant={Icons.PROFILE} />}
        className={styles.menuItem}
        onClick={handleViewProfile}
      >
        <span className={styles.menuItemSpan}>View Profile</span>
      </MenuItem>
      {client.InvitationStatus === 'Pending' ? (
        <>
          <MenuItem
            key={'copy'}
            icon={<Icons variant={Icons.COPY} color={'#FF576D'} />}
            className={styles.menuItem}
            onClick={handleCopyInviteLink}
          >
            <span className={styles.menuItemSpan}>Copy Invite Link</span>
          </MenuItem>
        </>
      ) : limitedAccess ? null : (
        <>
          <MenuItem
            key={'reassign'}
            icon={<Icons variant={Icons.REASSIGN} />}
            className={styles.menuItem}
            onClick={() => handleReassignClick('Reassign', client.Id)}
          >
            <span className={styles.menuItemSpan}>Reassign</span>
          </MenuItem>
        </>
      )}
    </Menu>
  );

  return (
    <Dropdown
      overlay={menu}
      placement="bottomRight"
      overlayClassName={styles.clientActionsMenu}
      trigger={['click']}
    >
      <div className={styles.outerContainer}>
        <div className={styles.container}>
          <Icons variant={Icons.HAMBURGER} className={styles.hbIcon} />
        </div>
      </div>
    </Dropdown>
  );
};

export default ClientActionsMenu;
